/* eslint-disable react-hooks/exhaustive-deps */
import { useNavigate } from "react-router-dom";
import RegisterSchedule from "./components/RegisterSchedule/RegisterSchedule";
import useSettingsResourceScheduleAdminContext from "./context/useSettingsResourceScheduleAdminContext";
import useRegisterScheduleData from "./utils/hooks/useRegisterScheduleData";
import ABSOLUTE_PATHS from "routes/utils/absolutePaths";
import DataHeaderDetail from "components/DataHeaderDetail/DataHeaderDetail";
import TimerIcon from "icons/TimerIcon";
import { Container, SettingsFormWrapper } from "../styles";
import { useEffect } from "react";
import useFilters from "./components/RegisterSchedule/components/Filters/utils/hooks/useFilters";

const ScheduleAdminCampusCoordinator = ({ campusId }) => {
	const { loadingRequest, data } = useSettingsResourceScheduleAdminContext();
	const navigate = useNavigate();
	const filters = useFilters({
		isUniqueCampus: true,
		data
	});
	const registerScheduleData = useRegisterScheduleData({
        loadingRequest, filters
    });
	useEffect(() => {
		filters.setCampusId(campusId);
    }, []);
	return (
		<Container>
			<DataHeaderDetail
				icon={<TimerIcon />}
				text="Administrador de Horarios"
				width="300px" />
			<SettingsFormWrapper>
				<RegisterSchedule
					filters={filters}
					registerScheduleData={registerScheduleData}
					cancelAction={() => navigate(ABSOLUTE_PATHS.SETTINGS)}/>
			</SettingsFormWrapper>
		</Container>
	);
}

export default ScheduleAdminCampusCoordinator;